import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";


export const getOrgInfo = ("fetchInfo/getOrgInfo", async (data) => {
    const req = `${BASE_URL}/organisation/getOrgInfo`;
    const params = {
      body: data
    }
    const encryptedBodyRes = await encryptPayload("",params,true,true);
    const options = {
        method: "post",
        headers : { 
          'Content-Type': 'application/json',
         },

         body: JSON.stringify(encryptedBodyRes)
      };

      try {
        const result = await encryptPayload(req, options, false, true,true);
        return result.data
        
      } catch (error) {
        throw error
      }
})